import { useQuery, useMutation } from '@tanstack/react-query'
import { API_URL } from '../const'
import axios from 'axios'
import { Geocontext, ScrapingGeocontext, OSMGeocontext, CommonsGeocontext } from '../types'
import { useAuthUser } from 'use-eazy-auth'

export async function getGeocontexts(
  token?: string,
  signal?: AbortSignal
) {
  return (
    await axios.get(`${API_URL}/geo-contexts/`, {
      signal,
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    })
  ).data as Geocontext[]
}

export function useGeocontexts() {
  const userData = useAuthUser()
  const token = userData?.token

  return useQuery({
    queryKey: ['geo-contexts', token],
    queryFn: ({ signal }) => getGeocontexts(token, signal),
    keepPreviousData: true,
    suspense: false,
    enabled: !!token,
  })
}

export async function getLastScrapingGeocontext(id: number) {
  return (
    await axios.get(`${API_URL}/geo-contexts/${id}/scraping/`)
  ).data as ScrapingGeocontext
}

export function useLastScrapingGeocontext(id: number) {
  return useQuery({
    queryKey: ['geo-contexts', id, 'scraping'],
    queryFn: () => getLastScrapingGeocontext(id),
    keepPreviousData: true,
    suspense: false,
    enabled: !!id,
  })
}


export async function startScraping(id: number, token: string) {
  return (
    await axios.post(`${API_URL}/geo-contexts/${id}/start-snapshot/`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
  )
}


export function useStartScraping(id: number) {
  const { token } = useAuthUser()
  return useMutation({
    mutationFn: () => startScraping(id, token!),

  })
}

export async function stopScraping(id: number, token: string) {
  return (
    await axios.post(`${API_URL}/geo-contexts/${id}/stop-snapshot/`, null, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
  )
}

export function useStopScraping(id: number) {
  const { token } = useAuthUser()
  return useMutation({
    mutationFn: () => stopScraping(id, token!),

  })

}

export async function getLastOSMStatusGeocontext(id: number, token?: string) {
  return (
    await axios.get(`${API_URL}/geo-contexts/${id}/osm-status/`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    })
  ).data as OSMGeocontext
}

export function useLastOSMStatusGeocontext(id: number) {
  const { token } = useAuthUser()
  
  return useQuery({
    queryKey: ['geo-contexts', id, 'osm-status'],
    queryFn: () => getLastOSMStatusGeocontext(id, token),
    keepPreviousData: true,
    suspense: false,
    enabled: !!id,
  })
}

export async function startOSM(id: number, token: string) {
  return (
    await axios.post(`${API_URL}/geo-contexts/${id}/start-osm/`, {

    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
  )
}


export function useStartOSM(id: number) {
  const { token } = useAuthUser()
  return useMutation({
    mutationFn: () => startOSM(id, token!),

  })
}


export async function stopOSM(id: number, token: string) {
  return (
    await axios.post(`${API_URL}/geo-contexts/${id}/stop-osm/`, {

    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
  )
}


export function useStopOSM(id: number) {
  const { token } = useAuthUser()
  return useMutation({
    mutationFn: () => stopOSM(id, token!),

  })
}



export async function getLastCommonsStatusGeocontext(id: number) {
  return (
    await axios.get(`${API_URL}/geo-contexts/${id}/commons-status/`)
  ).data as CommonsGeocontext
}

export function useLastCommonsStatusGeocontext(id: number) {
  return useQuery({
    queryKey: ['geo-contexts', id, 'commons-status'],
    queryFn: () => getLastCommonsStatusGeocontext(id),
    keepPreviousData: true,
    suspense: false,
    enabled: !!id,
  })
}

export async function startCommons(id: number, token: string) {
  return (
    await axios.post(`${API_URL}/geo-contexts/${id}/start-commons/`, {

    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
  )
}


export function useStartCommons(id: number) {
  const { token } = useAuthUser()
  return useMutation({
    mutationFn: () => startCommons(id, token!),

  })
}


export async function stopCommons(id: number, token: string) {
  return (
    await axios.post(`${API_URL}/geo-contexts/${id}/stop-commons/`, {

    }, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    })
  )
}


export function useStopCommons(id: number) {
  const { token } = useAuthUser()
  return useMutation({
    mutationFn: () => stopCommons(id, token!),

  })
}